import { Stack } from '@sureco/design-system'
import { Modal, Typography, Button } from 'antd'
import React from 'react'

const { Title, Text } = Typography

export default function ConflictModal({
  open,
  existing,
  onReplace,
  onCancel,
  isUploading,
}) {
  const languageLabel = existing?.language === 'spanish' ? 'Spanish' : 'English'

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={520}
      style={{ borderRadius: 16 }}
    >
      <Stack space={24} align="center">
        {/* Title */}
        <Title level={2} style={{ marginBottom: 0, textAlign: 'center' }}>
          Replace Existing?
        </Title>

        {/* File pill */}
        {existing && (
          <div
            style={{
              padding: '14px 18px',
              borderRadius: 12,
              background: '#F7FAFC',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <span
              style={{
                fontSize: 20,
                color: '#00A2AE',
                display: 'inline-flex',
              }}
            >
              📄
            </span>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              style={{
                color: '#00A2AE',
                fontSize: 16,
                textDecoration: 'none',
              }}
            >
              {existing.fileName}
            </a>
          </div>
        )}

        {/* Message */}
        <Text style={{ textAlign: 'center', fontSize: 15 }}>
          There is already an {languageLabel} PDF for this year.
          <br />
          What would you like to do?
        </Text>

        {/* Buttons */}
        <Stack space={12} style={{ width: '100%', alignItems: 'center' }}>
          <Button
            type="primary"
            size="large"
            block
            style={{
              height: 50,
              fontSize: 18,
              background: '#00A2AE',
              borderRadius: 12,
            }}
            onClick={onReplace}
            loading={isUploading}
          >
            Replace
          </Button>

          <Button
            type="text"
            onClick={onCancel}
            style={{
              color: '#9A9A9A',
              fontSize: 16,
            }}
          >
            Cancel This Upload
          </Button>
        </Stack>
      </Stack>
    </Modal>
  )
}
